import {Injectable} from "@angular/core";
import {BehaviorSubject} from "rxjs";

@Injectable({providedIn: "root"})
export class FeatureToggleService {
  public static features:BehaviorSubject<any> = new BehaviorSubject<any>(undefined)
}
